import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountTemplateLibraryImport implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxTemplateLibraryImportContainer";
    }
    render(){
        let root=this.zidx.peakidxShadowRoot;
        let textarea=root.querySelector(".zidxTemplateLibraryImportContainer textarea[name='template_library_import_json']") as HTMLTextAreaElement|null;
        if(!textarea || root.querySelector(".zidxTemplateLibraryImportContainer input[type='file']")){
            return;
        }
        let fileInput=document.createElement("input");
        fileInput.type="file";
        fileInput.accept=".json,application/json";
        fileInput.addEventListener("change", function(){
            let file=fileInput.files && fileInput.files[0];
            if(!file){
                return;
            }
            file.text().then(function(text:string){
                textarea.value=text;
            });
        });
        textarea.parentElement?.insertBefore(fileInput, textarea);
    }
}
